module.exports = __webpack_public_path__ + "img/wind.f7c6ab05.svg";